<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <div class="qi-content">
        <header>
          <h1>Seleção das eletivas/optativas do curso</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row vs-justify="left">
          <SelectedCourseBox></SelectedCourseBox>
          <SelectedOfferBox></SelectedOfferBox> </vs-row
        ><vs-row vs-justify="left">
          <h3 style="margin-bottom:10px">
            Selecione Eletivas para o Curso
          </h3></vs-row
        >
        <vs-row vs-justify="left"
          ><vs-col>
            <p>
              Para este curso é obrigatório selecionar:
              {{ countElectives }} disciplinas eletivas/optativas
            </p></vs-col
          >
        </vs-row>
        <vs-row vs-justify="left">
          <vs-col>
            <div class="space">
              <vs-checkbox
                v-for="(elective, electiveIndex) in electives"
                :key="electiveIndex"
                v-model="elective.selected"
                @change="onChangeCheckBox"
              >
                {{ elective.DISCIPLINA }}
              </vs-checkbox>
            </div>
            <vs-alert
              title="Problema na sequência"
              class="margin"
              color="danger"
              v-if="error"
            >
              {{ error }}
            </vs-alert>
          </vs-col>
        </vs-row>
        <vs-button
          icon="check_circle"
          style="width: 100%;"
          @click="goFoward()"
          type="filled"
          color="#139B0E"
          :disabled="buttonDisabled"
        >
          Avançar
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import SelectedCourseBox from "../components/SelectedCourseBox.vue";
import SelectedOfferBox from "../components/SelectedOfferBox.vue";
import { getStepsInformation } from "../helpers/storage";
import { formatDateToLocale, updateDiscussion } from "../helpers";

export default {
  name: "Electives",
  components: {
    SelectedCourseBox,
    SelectedOfferBox,
  },
  data: () => ({
    electives: [],
    error: null,
    countElectives: 1,
    buttonDisabled: true,
  }),
  created() {
    const { offer, electivesOptions } = getStepsInformation();
    this.electives = electivesOptions;
    this.countElectives = offer.NUMELETIVAS;
    if (this.countElectives == 0) this.buttonDisabled = false;
  },
  methods: {
    formatData(date) {
      return formatDateToLocale(date);
    },
    onChangeCheckBox() {
      const electivesSelected = this.electives.filter((elective) => {
        return elective.selected;
      });
      if (this.countElectives > 0)
        this.buttonDisabled = electivesSelected.length != this.countElectives;
    },
    goFoward() {
      const selectedElectives = this.electives.filter(
        (elective) => elective.selected
      );
      const electivesText = selectedElectives
        .map((elective) => elective.DISCIPLINA)
        .join(", ");
      if (selectedElectives.length > 0) {
        updateDiscussion(`Selecionou Eletivas: ${electivesText}`, {
          electives: selectedElectives,
        }).finally(() => {
          this.$router.push("/classes");
        });
      } else {
        this.$router.push("/classes");
      }
    },
  },
};
</script>

<style>
.vs-list {
  text-align: initial;
}

.space .con-vs-checkbox {
  margin-bottom: 8px;
  justify-content: flex-start;
}
</style>
